import React from "react";
import CoachingPage from "./CoachingPage";

const FreeHelpWithRayPage: React.FC = () => (
  <CoachingPage hideNavigation requireFreeHelpQualification />
);

export default FreeHelpWithRayPage;
